/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TaskJobStatusGenre {
    System = 1,
    Client = 2,
}
